<template>
  <fin-data-loader :resolver="loadData">
    <div v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
         v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
         class="pt-12 pb-5 text-center">
      <h1>Orderliste erstellen</h1>
      <p class="mt-6">Hier kannst du demnächst die Transaktionen deines finCraft Portfolios direkt per Wertpapierorder
        an ausgewählte
        Broker übertragen.</p>
      <fin-work-in-progress max-width="500px"/>
    </div>

    <div v-if="!isIos && !isMobile"
         v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
         v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
         class="pb-5 text-center">
      <p>
        Als kleine Hilfe und Übergangslösung kannst du hier dein Portfolio als Excel herunterladen als Ordervorlage
        zum Bearbeiten oder Ausdrucken.</p>
      <v-btn :disabled="!excelDownloadEnabled"
             @click="exportExcel" dark>
        Als Excel speichern
      </v-btn>
    </div>
  </fin-data-loader>
</template>

<script>
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {exportPortfolio} from "@/js/finMutations"
import AmplitudePush from "@/mixins/AmplitudePush"
import finBrowser from "@/js/finBrowser"
import FinWorkInProgress from "@/components/common/WorkInProgress"
import {onUpdatePortfolioStatus} from "@/js/finSubscriptions"
import FinDataLoader from "@/components/common/DataLoader"
import {mapGetters} from "vuex"
import SubscriptionHandler from "@/mixins/SubscriptionHandler"
import {EventBus} from "@/plugins/fincraft"
import PriceModel from "@/mixins/PriceModel"
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"

//Loads all details for the detailview
const queryPortfolioStatus = `
  query GetPortfolio($id: ID!) {
    getPortfolio(id: $id) {
      id
      status {
        calculationStatus
        calculationMessage
      }
    }
  }
`

export default {
  name: "FinCreateOrderList",
  components: {FinDataLoader, FinWorkInProgress},
  props: {
    // portfolio id automatically set by the routing as this page is defined under portfoliodDetails and props is set to true
    id: {
      type: String
    }
  },
  data() {
    return {
      isIos: finBrowser.IS_IOS(),
      isMobile: finBrowser.IS_MOBILE(),
      portfolio: undefined
    }
  },
  mixins: [AmplitudePush, SubscriptionHandler, PriceModel],
  methods: {
    async loadData() {
      let result = await API.graphql(graphqlOperation(queryPortfolioStatus, {
        id: this.id
      }))

      this.portfolio = result.data.getPortfolio
      this.subscribePortfolioMutations()
    },
    trackToAmplitude(action) {
      const event = {
        'event': 'fincraft_orderlist_' + action,
        'step': action,
        'vue_breakpoint': this.$vuetify.breakpoint.name
      }
      this.pushToAmplitude(event)
    },
    async exportExcel() {
      this.trackToAmplitude('export_portfolio')
      if (this.isPriceModelFeatureEnabled(PRICEMODEL_FEATURE_IDS.PORTFOLIO_UPLOAD_DOWNLOAD.id) === false) {
        EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.PORTFOLIO_UPLOAD_DOWNLOAD.id, PRICEMODEL_FEATURE_RESTRICTIONS.UNAVAILABLE)
      } else {
        let exportURL = await API.graphql(graphqlOperation(exportPortfolio, {
          portfolioId: this.id,
          format: 'XLSX',
        }))

        if (exportURL.data.exportPortfolio) {
          const fileName = exportURL.data.exportPortfolio.substr(exportURL.data.exportPortfolio.indexOf('/Download') + 1)
          const signedURL = await this.$Amplify.Storage.get(fileName, {level: 'private'})

          if (signedURL) {
            const a = document.createElement("a")
            a.href = signedURL
            a.setAttribute('download', exportURL.data.exportPortfolio.substr(exportURL.data.exportPortfolio.lastIndexOf('/') + 1))
            a.target = '_blank'

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
        }
      }
    },
    subscribePortfolioMutations() {
      // subscribe to portfolio status changes
      this.subscribeToChanges(
        this.portfolio,
        onUpdatePortfolioStatus,
        (pf) => {
          return {owner: this.userId, id: pf.id}
        },
        this.handlePortfolioStatusSubscription
      )
    },
    handlePortfolioStatusSubscription(newData, item) {
      // update button to download excel
      this.portfolio = newData.data.onUpdatePortfolio
    }
  },
  computed: {
    ...mapGetters('auth', ['userId']),
    excelDownloadEnabled() {
      return this.portfolio && this.portfolio.status && this.portfolio.status.calculationStatus === 'OK'
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
